import {
  trackDefaultPublicationClick,
  trackRecommendedPackageClick,
  trackShowRecommendedPackagesWidget,
} from './tracking';
import { getTrackingSiteType, mapPackageTrackingData } from './utils';
import { useCallback, useContext } from 'react';
import { useSelector } from 'react-redux';
import {
  selectAnalyticsOfferStatus,
  selectAnalyticsProduct,
  selectAnalyticsExtraOfferIds,
} from '../../../../../../../selectors/analytics';
import { AppContext } from '../../../../../../../../AppModulesWrapper';
import { selectIsMobileLayout } from '../../../../../../../selectors/layout';
import { IRecommendedPackage } from '../../../../../../../types/reducers/recommendedPackages';
import { selectRecommendedPackages } from '../../../../../../../reducers/v2/recommendedPackages/selectors';

export const useRecommendedPackageTrackers = () => {
  const { isMicrofrontend } = useContext(AppContext);
  const analyticsOfferStatus = useSelector(selectAnalyticsOfferStatus);
  const isMobile = useSelector(selectIsMobileLayout);
  const recommendedPackages = useSelector(selectRecommendedPackages);
  const siteType = getTrackingSiteType(Boolean(isMicrofrontend), isMobile);
  const { variant: vas } = useSelector(selectAnalyticsProduct);
  const analyticsExtraOfferIds = useSelector(selectAnalyticsExtraOfferIds);

  const trackOnRecommendedPackageClick = useCallback(
    (recommendedPackage: IRecommendedPackage) => {
      trackRecommendedPackageClick({
        packageInfo: mapPackageTrackingData(recommendedPackage),
        analyticsExtraOfferIds,
        analyticsOfferStatus,
        siteType,
        vas,
      });
    },
    [analyticsOfferStatus, siteType, vas, analyticsExtraOfferIds],
  );

  const trackOnShowRecommendedPackagesWidget = useCallback(() => {
    trackShowRecommendedPackagesWidget({
      // TODO: мапить recommendedPackages один раз
      packagesInfo: recommendedPackages.map(recommendedPackage => mapPackageTrackingData(recommendedPackage)),
      analyticsExtraOfferIds,
      analyticsOfferStatus,
      siteType,
      vas,
    });
  }, [analyticsOfferStatus, analyticsExtraOfferIds, recommendedPackages, siteType, vas]);

  const trackOnDefaultPublicationClick = useCallback(() => {
    trackDefaultPublicationClick({
      analyticsExtraOfferIds,
      analyticsOfferStatus,
      siteType,
      vas,
    });
  }, [analyticsOfferStatus, analyticsExtraOfferIds, siteType, vas]);

  return {
    trackOnRecommendedPackageClick,
    trackOnShowRecommendedPackagesWidget,
    trackOnDefaultPublicationClick,
  };
};
